import { object } from "prop-types";

export function isEmpty (value) {
    if (value === null) return true
	if (value === undefined) return true
	if (value === '') return true
    if (typeof value === 'undefined') return true
    if (typeof value === 'string' && value === '') return true
    if (Array.isArray(value) && value.length < 1) return true
    if (typeof value === 'object' && value.constructor.name === 'Object' && Object.keys(value).length < 1 && Object.getOwnPropertyNames(value) < 1) return true
    if (typeof value === 'object' && value.constructor.name === 'String' && Object.keys(value).length < 1) return true // new String()

    return false
}

export function getLanguage() {
	const lang = navigator.language
	
	if (lang === "ko" || lang === "ko-KR") {
		return "ko_KR"
	} else {
		return "en_US"
	}
};

export function isStringToJson(data) {
	try{
		const json = JSON.parse(data)
		return (typeof json === "object") ? json : null;
	} catch(e) {
		return null;
	}
}

export function isJsonToString(data) {
	try{
		return (typeof data === "string") ? data : JSON.stringify(data);
	} catch(e) {
		return data
	}
}

export function getSettingsKeyWithoutAppPostfix(key) {
	try {
		return key.split("_")[0];
	} catch {
		return key;
	}
}

export function getSettingKeyApp(key) {
	try {
		return key.split("_")[1];
	} catch {
		return null;
	}
}

const URL_REGEX = /^(?:https?|ftp):\/\/(?:[\w.-]+(?::[\w.-]+)?@)?[A-Za-z0-9.-]+(?::\d+)?(?:\/[^\s]*)?$/;

export function invalidURI(url) {
    if (typeof url !== 'string') {
        return true;
    }

    if (url.length > 2048) {
        return true;
    }

    if (!URL_REGEX.test(url)) {
        return true;
    }

    return false;
}

export function invalidHost(host) {
    if (typeof host !== 'string') {
        return false;
    }

    if (host.length > 2048) {
        return false;
    }

    return URL_REGEX.test(host);
}

export function getTime(date) {
	return`${padZero(date.getHours())}:${padZero(date.getMinutes())}:${padZero(date.getSeconds())}`;
}

export function removeTrailingSlash(url) {
    if (url.charAt(url.length - 1) === '/') {
        return url.slice(0, -1);
    }
    return url;
}

function padZero(num) {
	return num < 10 ? `0${num}` : num;
}